import { createContent, getDisplayAssetCode } from '@altify/utils';

export const content = createContent({
  en: {
    title: (productCode?: string, productName?: string) =>
      productName
        ? `Sell ${productName} (${getDisplayAssetCode(productCode)})`
        : '',
  },
  de: {
    title: (productCode?: string, productName?: string) =>
      productName
        ? `Verkaufe ${productName} (${getDisplayAssetCode(productCode)})`
        : '',
  },
});
